var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * Base class representing cipher parameter metadata (e.g., whether key is private).
 *
 * @private
 */
var _PdfCipherParameter = /** @class */ (function () {
    function _PdfCipherParameter(isPrivate) {
        this._isPrivate = isPrivate;
    }
    return _PdfCipherParameter;
}());
export { _PdfCipherParameter };
var _PdfRonCipherParameter = /** @class */ (function (_super) {
    __extends(_PdfRonCipherParameter, _super);
    function _PdfRonCipherParameter(isPrivate, modulus, exponent) {
        var _this = _super.call(this, isPrivate) || this;
        _this._modulus = modulus;
        _this._exponent = exponent;
        return _this;
    }
    return _PdfRonCipherParameter;
}(_PdfCipherParameter));
export { _PdfRonCipherParameter };
